import React from 'react';
import { Button } from '../button/button';
import { SectionHeaderTitle } from '../section-header-title/section-header-title';
import { ScrollPosition } from '../../core/hooks/use-carousel';
import styles from './section-header-carousel.module.scss';

type Props = {
  children: React.ReactNode;
  scrollPosition: ScrollPosition;
  onNext: () => void;
  onPrev: () => void;
};

const CarouselNavigation: React.FC<{
  scrollPosition: 'start' | 'middle' | 'end' | 'no-scroll';
  onNext: () => void;
  onPrev: () => void;
}> = ({ scrollPosition, onNext, onPrev }) => {
  if (scrollPosition === 'no-scroll') {
    return null;
  }

  return (
    <div className={styles.carouselNavigation}>
      <Button disabled={scrollPosition === 'start'} icon="arrow-left" variant="secondary" onClick={onPrev} />
      <Button disabled={scrollPosition === 'end'} icon="arrow-right" variant="secondary" onClick={onNext} />
    </div>
  );
};

export const SectionHeaderCarousel: React.FC<Props> = ({ children, scrollPosition, onNext, onPrev }) => {
  return (
    <div className={styles.root}>
      <SectionHeaderTitle>{children}</SectionHeaderTitle>
      <CarouselNavigation scrollPosition={scrollPosition} onNext={onNext} onPrev={onPrev} />
    </div>
  );
};
